import { combineReducers } from 'redux';
import userState, { IUserState } from './UserReducer';
import loginState, { ILoginState } from '@src/reducers/LoginReducer';
import preloaderState, { IPreloaderState } from '@src/reducers/PreloaderReducer';
import alertState, { IAlertState } from '@src/reducers/AlertReducer';

export default combineReducers<RootState>({
    userState,
    loginState,
    preloaderState,
    alertState,
});

export interface RootState {
    userState: IUserState;
    loginState: ILoginState;
    preloaderState: IPreloaderState;
    alertState: IAlertState;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/index.ts